import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ConfigContext = createContext(null);

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const { status } = useAuth();

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/config");
      setConfig(data);
    } catch (e) {
      // 401s are handled by AuthContext interceptor
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (status === "authed") refresh();
  }, [status, refresh]);

  return (
    <ConfigContext.Provider value={{ config, loading, refresh }}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => useContext(ConfigContext);
